import createComponent from '@carvana/merch-components/createComponent';

export const Wrapper = createComponent('main', {
  className:
    'flex flex-col items-center justify-center bg-white px-28 py-20 m:px-[120px] m:py-0 lg:px-[300px] landscape:max-m:px-[180px]'
});
